import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { TipoVisitaModel } from 'src/app/models/tipo-visita/TipoVisitaModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { environment } from 'src/environments/environment';
import { ITipoVisitaModel } from 'src/app/models/interfaces/tipo-visita/ITipoVisitaModel';
import { IFilterTipoVisitaModel } from 'src/app/models/interfaces/tipo-visita/IFilterTipoVisitaModel';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';

@Injectable({
  providedIn: 'root'
})
export class TipoVisitaService {
  // private configUrl = 'api/tipos-visita';
  private configUrl = [environment.apiGatewayUrl, 'tipos-visita'].join('/');

  constructor(private http: HttpClient) { }

  getListPaged(
    model: IFilterTipoVisitaModel
  ) : Observable<SearchResultModel<ITipoVisitaModel[]>> {
    let queryParams: string[] = new Array<string>();

    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    queryParams.push(`idEstado=${model.idEstado}`);

    if (model.tipoVisita !== '') {
      queryParams.push(`tipoVisita=${model.tipoVisita}`);
    }

    return this.http.get<SearchResultModel<ITipoVisitaModel[]>>(
      this.configUrl + '?'+ queryParams.join('&')
      );
  }

  getList(
    model: IFilterTipoVisitaModel
  ) : Observable<ITipoVisitaModel[]> {
    let queryParams: string[] = new Array<string>();

    queryParams.push(`idEstado=${model.idEstado}`);

    return this.http.get<ITipoVisitaModel[]>(
      `${this.configUrl}/all/?${queryParams.join('&')}`
      );
  }

  getById(id: number): Observable<ITipoVisitaModel> {
    return this.http.get<ITipoVisitaModel>(`${this.configUrl}/${id}`);
  }

  submit(model: ITipoVisitaModel) {
    return this.http.post<ITipoVisitaModel>(`${this.configUrl}`, model);
  }

  update(model: ITipoVisitaModel) {
    return this.http.put<ITipoVisitaModel>(
      `${this.configUrl}/${model.idTipoVisita}`,
      model
    );
  }

  defaultcontratista(model: ITipoVisitaModel) {
    return this.http.put<ActionResultModel>(
      `${this.configUrl}/${model.idTipoVisita}/defaultcontratista`,
      model
    );
  }

  delete(id: number) {
    return this.http.delete<ITipoVisitaModel>(`${this.configUrl}/${id}`);
  }
}
